module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1Ca461j/tc-custom/9781488060601.jpg?1728259357480",
      "alt": "This image is the cover for the book Daughter for Christmas, Triple Creek Cowboys"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Daughter for Christmas, Triple Creek Cowboys\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("This little girl needs a holiday to remember…"), _c('br'), _c('br'), _c('b', [_vm._v("To give her a real Christmas,"), _c('br'), _c('br'), _vm._v("they’ll risk a surprising second chance."), _c('br'), _c('br')]), _vm._v("Single mom Eve Fallon hopes a real country Christmas will help her young daughter, Alice, to overcome trauma. Widowed rancher Tanner Cole doesn’t believe in much of anything since his own tragic loss. But as his steady patience coaxes Alice out of her shell, Eve works to rekindle his holiday happiness. Together they might be able to heal…and make a family for a lifetime."), _c('br'), _c('br'), _c('b', [_vm._v("From Harlequin Love Inspired: Uplifting stories of faith, forgiveness and hope."), _c('br'), _c('br'), _vm._v("Triple Creek Cowboys"), _c('br'), _c('br')]), _vm._v("Book 1: "), _c('i', [_vm._v("The Cowboy’s Twin Surprise"), _c('br'), _c('br')]), _vm._v("Book 2: "), _c('i', [_vm._v("The Cowboy’s Unexpected Baby"), _c('br'), _c('br')]), _vm._v("Book 3: "), _c('i', [_vm._v("A Daughter for Christmas")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Stephanie Dees\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Award-winning author Stephanie Dees lives in small-town Florida with her pastor husband and their two youngest children. A Southern girl through and through, she loves sweet tea, SEC football, corn on the cob and air-conditioning. For further information, please visit her website at stephaniedees.com."), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0